import * as React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import * as T from '../../Typography';
import * as S from './styles';
import { useAuth } from '../../../context/auth';
import logo from '../../assets/logo-white.png';
import NavButton from '../NavButton';
import { CloseRounded, HeadsetMic, List, Settings } from '@mui/icons-material';
import Button from '../../Button';
import { Grid } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import colors from '../../../theme/colors';
import { useState } from 'react';
import SupportModal from '../../SupportModal';
import { Link } from 'react-router-dom';

const Navigation = () => {
  const [drawerOpen, setDrawerOpen] = React.useState(false);
  const { logout } = useAuth();
  const [showSupportModal, setShowSupportModal] = useState(false);

  const isMobile = useMediaQuery('(max-width:600px)');

  return (
    <>
      {!isMobile ? (
        <>
          <S.Bar position="static" id="menu-container">
            <S.Container container>
              <Grid item>
                <Box>
                  <Link to="/">
                    <img src={logo} alt="smf" width="118" height="48" />
                  </Link>
                </Box>
              </Grid>
              <Grid item>
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  {/* <Grid item mx={1}>
                    <NavButton
                      variant="blue"
                      external="xxx"
                      width="fit-content"
                      icon={<Settings />}
                    >
                      Settings
                    </NavButton>
                  </Grid> */}
                  <Grid item>
                    <NavButton
                      variant="blue"
                      width="fit-content"
                      icon={<HeadsetMic />}
                      mr={2}
                      handleClick={() => setShowSupportModal(true)}
                    >
                      Support
                    </NavButton>
                  </Grid>
                  <Grid item>
                    <Button
                      size="medium"
                      variant="secondary"
                      width="fit-content"
                      external={'xxx'}
                      onClick={() => logout()}
                    >
                      Log out
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </S.Container>
          </S.Bar>
        </>
      ) : (
        <>
          {/* MOBILE MENU */}
          <S.Bar position="static" id="menu-container">
            <S.Container px={{ xs: 3, tablet: 10 }} py={0}>
              <Grid item>
                <Box>
                  <Link to="/">
                    <img src={logo} alt="smf" width="118" height="48" />
                  </Link>
                </Box>
              </Grid>
              <Grid item>
                <Box
                  sx={{
                    flexGrow: 1,
                    justifyContent: 'flex-end',
                    position: 'relative',
                    display: {
                      xs: 'flex',
                      tablet: 'none',
                      desktop: 'none'
                    }
                  }}
                >
                  <IconButton
                    size="large"
                    aria-label="open-menu"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={() => setDrawerOpen(!drawerOpen)}
                    color="inherit"
                    sx={{ padding: 0, width: '32px', height: '32px' }}
                  >
                    {drawerOpen ? (
                      <CloseRounded
                        sx={{ width: 32, height: 32 }}
                        htmlColor={colors.neutral.shades.shade50}
                      />
                    ) : (
                      <List
                        sx={{ width: 32, height: 32 }}
                        htmlColor={colors.neutral.shades.shade50}
                      />
                    )}
                  </IconButton>
                </Box>
              </Grid>
            </S.Container>
            {/* open drawer for mobile menu */}
            {drawerOpen && (
              <S.Menu id="menu-appbar">
                <MenuItem
                  sx={{
                    paddingLeft: {
                      xs: 3,
                      tablet: 10
                    }
                  }}
                  onClick={() => setShowSupportModal(true)}
                >
                  <T.Link textAlign="center">Support</T.Link>
                </MenuItem>
                <MenuItem
                  onClick={() => null}
                  sx={{
                    paddingLeft: {
                      xs: 3,
                      tablet: 10
                    }
                  }}
                >
                  <T.Link
                    textAlign="center"
                    to={'/'}
                    onClick={() => setDrawerOpen(!drawerOpen)}
                  >
                    Settings
                  </T.Link>
                </MenuItem>
                <MenuItem
                  onClick={() => null}
                  sx={{
                    paddingLeft: {
                      xs: 3,
                      tablet: 10
                    }
                  }}
                >
                  <T.Link textAlign="center" onClick={() => logout()}>
                    Log out
                  </T.Link>
                </MenuItem>
              </S.Menu>
            )}
          </S.Bar>
        </>
      )}
      <SupportModal
        visible={showSupportModal}
        setIsModalVisible={() => setShowSupportModal(!showSupportModal)}
      />
    </>
  );
};
export default Navigation;
